/**
 * Initial State View Component
 * Displays placeholder stats before optimization runs
 */
import { Users, TrendingUp, Clock } from 'lucide-react';

interface InitialStateViewProps {
  totalPopulation: number;
}

export default function InitialStateView({ totalPopulation }: InitialStateViewProps) {
  const statCardStyle = {
    padding: '0.75rem',
    backgroundColor: 'var(--bg-secondary)',
    borderRadius: '8px',
    border: '1px solid var(--border-color)',
    flex: 1,
    minWidth: '140px',
  };

  const statLabelStyle = {
    fontSize: '0.75rem',
    color: 'var(--text-secondary)',
    marginBottom: '0.15rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  };

  const statValueStyle = {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: 'var(--text-primary)',
  };

  const placeholderValueStyle = {
    ...statValueStyle,
    color: 'var(--text-secondary)',
  };

  return (
    <div>
      {/* Stats Grid */}
      <div style={{ 
        display: 'flex', 
        gap: '1rem', 
        flexWrap: 'wrap',
        marginTop: '-0.5rem',
      }}>
        <div style={statCardStyle}>
          <div style={statLabelStyle}>
            <Users size={14} />
            Total Population
          </div>
          <div style={statValueStyle}>
            {totalPopulation.toLocaleString()}
          </div>
        </div>

        <div style={statCardStyle}>
          <div style={statLabelStyle}>
            <TrendingUp size={14} />
            2-Day Coverage
          </div>
          <div style={placeholderValueStyle}>
            —
          </div>
        </div>

        <div style={statCardStyle}>
          <div style={statLabelStyle}>
            <TrendingUp size={14} />
            3-Day Coverage
          </div>
          <div style={placeholderValueStyle}>
            —
          </div>
        </div>

        <div style={statCardStyle}>
          <div style={statLabelStyle}>
            <Clock size={14} />
            Avg Delivery
          </div>
          <div style={placeholderValueStyle}>
            —
          </div>
        </div>
      </div>
    </div>
  );
}

